import { Components, Theme } from '@mui/material';

import { FONT_FAMILY } from '../const';

export function getMuiTypography(theme: Theme): Components['MuiTypography'] {
  return {
    defaultProps: {
      fontFamily: FONT_FAMILY,
      variantMapping: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
        subtitle1: 'div',
        subtitle2: 'div',
        body1: 'div',
        body2: 'div',
      },
    },
    styleOverrides: {
      root: {
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        fontFeatureSettings:
          '"ss01" on, "case" on, "salt" on, "calt" off, "tnum" on',
        lineHeight: 'normal',
        fontStyle: 'normal',
        fontWeight: 400,
      },

      h1: {
        fontWeight: 700,
        fontSize: 40,
        letterSpacing: '-1px',

        [theme.breakpoints.down('sm')]: {
          fontSize: 32,
        },
      },

      h2: {
        fontWeight: 700,
        fontSize: 30,

        [theme.breakpoints.down('sm')]: {
          fontSize: 21,
        },
      },

      h3: {
        fontWeight: 700,
        fontSize: 24,
      },

      h4: {
        fontWeight: 600,
        fontSize: 20,

        [theme.breakpoints.down('sm')]: {
          fontSize: 16,
        },
      },

      h5: {
        fontSize: 16,
        fontWeight: 600,
      },

      body1: {
        fontSize: 14,
      },

      body2: {
        fontSize: 12,
      },

      subtitle1: {
        fontSize: 14,
        fontWeight: 500,

        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
        },
      },
    },
  };
}
